import { createApp } from 'vue';
import App from './App.vue';
import './index.css';
import router from './router';
import VueClickAway from 'vue3-click-away';
import { ApiKey } from './api/symbols';
import api from './api/client';
import * as Sentry from '@sentry/vue';

const app = createApp(App);
if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://e4e839bff829416f8a96cad88e0c00d4@o29515.ingest.sentry.io/4505551086354432',
    environment: 'development',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

app.use(VueClickAway).use(router).mount('#app');

app.provide(ApiKey, api);
